var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#3955a3;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visio_48x1_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_48",
    "data-name": 48
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.04,
    y: 11,
    width: 32.96,
    height: 49,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,12V59H35V12H66m0-2H35a2,2,0,0,0-2,2V59a2,2,0,0,0,2,2H66a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.44,23.44l-7.88-7.88a1.5,1.5,0,0,0-2.12,0L46,23H40v3h6l7,7V45H48V39.5A1.5,1.5,0,0,0,46.5,38h-10A1.5,1.5,0,0,0,35,39.5v14A1.5,1.5,0,0,0,36.5,55h10A1.5,1.5,0,0,0,48,53.5V48h6.5A1.5,1.5,0,0,0,56,46.5V33l7.44-7.44A1.5,1.5,0,0,0,63.44,23.44ZM45,52H38V41h7Zm9.5-21.74L48.74,24.5l5.76-5.76,5.76,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,4,4,11V61l38,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,24.22,24,49.15,18.91,49,12.17,24l4.79.06,4.16,17.4a13.71,13.71,0,0,1,.4,2.5h.09A15.87,15.87,0,0,1,22,41.42l4.17-17.25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisio);
export default __webpack_public_path__ + "static/media/visio.f10c96367bab5795e2940232f6eb37f5.svg";
export { ForwardRef as ReactComponent };